import { createFeatureSelector, createSelector } from '@ngrx/store';
import { PairState } from './pair.state';
import { pairFeatureKey } from './pair.reducers';

export const seletPairState = createFeatureSelector<PairState>(pairFeatureKey);

export const seletPair = createSelector(seletPairState, (state: PairState) => state);